import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { AgentRecord, CreateAgentRequest } from "../AgentRecord";

interface CreateAgentParams {
  orgId: string;
  request: CreateAgentRequest;
}

/**
 * Mutation hook for creating an agent.
 *
 * Invalidates the ``agents`` list query on success so the Agents tab
 * refetches without the caller having to wire up its own ``onSuccess``
 * callback.
 */
export function useCreateAgent() {
  const { agentService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<AgentRecord, Error, CreateAgentParams>({
    mutationFn: ({ orgId, request }) =>
      agentService.createAgent(request, { orgId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["agents"] });
    },
  });
}
